"use strict";

module.exports = require("./E164PhoneHandler.js");